import styled from "styled-components";
import { Box, IconButton, TextField } from "@mui/material";

export const RootContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  marginBottom: "20px",
  width: "100%",
  padding: "20px",
  backgroundColor: theme.palette.background.paper,
  [theme.breakpoints.down("lg")]: {
    flexDirection: "column",
  },
}));

export const DragContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  marginRight: "20px",
  marginBottom: "30px",
  [theme.breakpoints.down("lg")]: {
    width: "100%",
    justifyContent: "space-between",
    marginRight: 0,
    marginBottom: "30px",
  },
}));

export const DragIcon = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
}));

export const DragLabel = styled(Box)(({ theme }) => ({
  display: "none",
  [theme.breakpoints.down("lg")]: {
    display: "block",
  },
}));

export const DeleteIcon = styled(Box)(({ theme }) => ({
  marginLeft: "10px",
  marginBottom: "30px",
  [theme.breakpoints.down("sm")]: {
    display: "none",
  },
}));

export const ContentContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  flex: 1,
  justifyContent: "space-evenly",
  width: "100%",
  gap: "30px",
  [theme.breakpoints.down("lg")]: {
    flexDirection: "column",
  },
}));

export const ContentColumn = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "30px",
  width: "100%",
  flex: 1,
}));

export const NameRow = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: "30px",
  width: "100%",
  [theme.breakpoints.down("lg")]: {
    flexDirection: "column",
  },
}));

export const DescriptionRow = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: "30px",
}));
